import { observer } from 'mobx-react'
import React, { Fragment, useEffect } from 'react'
import { Col, FormGroup, Row } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import BreadCrumbs from 'src/Components/Authenticated/BreadCrumbs'
import Portlet from 'src/Components/Authenticated/Portlet'
import LoaderIcon from 'src/Components/LoaderIcon'
import McButton from 'src/Components/McButton'
import { MainPage } from 'src/Components/My'
import { t } from 'src/I18n'
import EditPosModal from './EditPosModal/EditPosModal'
import { posDetailsStore } from './Store'
import TerminalsGrid from './TerminalsGrid/TerminalsGrid'

const Details: React.FC = () => {
  const params = useParams<'posGuid'>()
  const posGuid = params.posGuid

  useEffect(() => {
    posDetailsStore.Initialize(posGuid)
  }, [null])

  const { ViewModel, IsLoading, ShowEditPos } = posDetailsStore

  const renderEditPos = () => {
    if (!ShowEditPos) {
      return null
    }

    return (
      <EditPosModal
        onClose={() => posDetailsStore.ToggleShowEditPos(false)}
        onSubmitSuccess={(viewModel) => {
          posDetailsStore.UpdateViewModel(viewModel)
        }}
        editPos={{ ...ViewModel }}
      />
    )
  }

  return (
    <MainPage>
      <LoaderIcon IsLoading={IsLoading} />

      <br className="xs-10" />
      {!IsLoading && ViewModel !== undefined && (
        <Fragment>
          <BreadCrumbs
            currentPageTitle={ViewModel.Name}
            previousPages={[
              {
                to: '/merchants',
                title: t.common.merchants,
              },
              {
                to: `/merchant/details/${ViewModel.MerchantGuid}`,
                title: ViewModel.MerchantName,
              },
              {
                to: `/location/details/${ViewModel.LocationGuid}`,
                title: ViewModel.LocationName,
              },
            ]}
          />

          <Portlet title={t.common.pos}>
            <Row className="details">
              <Col md={6}>
                <FormGroup>
                  <label>Id</label>
                  <span>{ViewModel.PosId}</span>
                </FormGroup>
                <FormGroup>
                  <label>
                    {t.pos.insert.fields.Name.label}
                    <McButton
                      iconLeft="fa-edit"
                      bsStyle="primary"
                      bsSize="xsmall"
                      pullRight
                      onClick={() => {
                        posDetailsStore.ToggleShowEditPos(true)
                      }}
                    >
                      {t.common.edit}
                    </McButton>
                  </label>
                  <span>{ViewModel.Name}</span>
                </FormGroup>
                <FormGroup>
                  <label>{t.pos.insert.fields.PosTypeID.label}</label>
                  <span>{ViewModel.PosTypeName}</span>
                </FormGroup>
                <FormGroup>
                  <label>{'BranchId (MyArantek Filiaal nummer)'}</label>
                  <span>{ViewModel.BranchId}</span>
                </FormGroup>
              </Col>
            </Row>
          </Portlet>
          <Portlet title={t.common.terminals}>
            <TerminalsGrid
              posGuid={ViewModel.PosGuid}
              posName={ViewModel.Name}
            />
          </Portlet>
        </Fragment>
      )}
      {renderEditPos()}
    </MainPage>
  )
}

export default observer(Details)
